module.exports = __webpack_public_path__ + "img/Cover.d3ceebf9.jpg";